import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BackupRestoreSection from '../../components/BackupRestoreSection';

/** Same backup UI as before — standalone page under Mon profil */
const AdminProfileBackups = () => (
  <div className="space-y-6">
    <Link
      to="/admin-profile"
      className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 transition-colors hover:text-red-600"
    >
      <ArrowLeft className="h-4 w-4" />
      Retour à Mon profil
    </Link>
    <BackupRestoreSection />
  </div>
);

export default AdminProfileBackups;
